import { cva } from "class-variance-authority";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { KpiModelTreeVersion } from "@/types/serializers";

interface VersionTabsProps {
  versions: KpiModelTreeVersion[];
  currentVersionId: number | null;
  onChange: (versionId: string) => void;
}

const statusBadgeVariants = cva("ml-1.5 text-[10px] px-1.5 py-0", {
  variants: {
    status: {
      current: "bg-chart-6/20 text-chart-6 border-chart-6/30",
      draft: "bg-chart-2/20 text-chart-2 border-chart-2/30",
    },
  },
});

export function VersionTabs({
  versions,
  currentVersionId,
  onChange,
}: VersionTabsProps) {
  if (versions.length <= 1) return null;

  return (
    <Tabs value={currentVersionId?.toString() ?? ""} onValueChange={onChange}>
      <TabsList className="h-8">
        {versions.map((v) => (
          <TabsTrigger
            key={v.id}
            value={v.id.toString()}
            className="text-sm py-1 px-2.5"
          >
            {v.name}
            {v.status === "draft" && (
              <Badge
                variant="outline"
                className={statusBadgeVariants({ status: "draft" })}
              >
                draft
              </Badge>
            )}
            {v.is_current && (
              <Badge
                variant="outline"
                className={statusBadgeVariants({ status: "current" })}
              >
                current
              </Badge>
            )}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
